import { useCallback, useContext } from "react";
import { useIntl } from "react-intl";

import { lockBrand } from "@/shared/lib/brand";
import { LocaleContext } from "@/shared/i18n/LocaleProvider";
import { localizeNumberValues } from "@/shared/i18n/localizedNumbers";
import type { MessageId } from "@/shared/i18n/messages";

type MessageValues = Record<string, string | number>;

/** Translate a message id. Every result passes through lockBrand. */
export function useT(): (id: MessageId, values?: MessageValues) => string {
  const intl = useIntl();
  return useCallback(
    (id: MessageId, values?: MessageValues) =>
      lockBrand(
        intl.formatMessage(
          { id },
          localizeNumberValues(intl.messages[id], values, (value) =>
            intl.formatNumber(value, { useGrouping: false }),
          ),
        ),
      ),
    [intl],
  );
}

export function useLocale() {
  const context = useContext(LocaleContext);
  if (context === null) {
    throw new Error("useLocale must be used inside LocaleProvider");
  }
  return context;
}
